import { CalendarItemUnion } from '$tablet-app/src/app/calendar/types';
import NewButton from '$tablet-app/src/app/components/Button/NewButton';
import FullScreenLoader from '$tablet-app/src/app/components/FullScreenLoader';
import Row from '$tablet-app/src/app/components/Row';
import Text from '$tablet-app/src/app/components/Text';
import TodayBadge from '$tablet-app/src/app/components/TodayBadge';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { format, isSameDay } from 'date-fns';
import React, { FC } from 'react';
import styled from 'styled-components/native';
import { useGetCalendarItemsForDay } from '../../hooks';
import CalendarDayBreakdownSchedule from '../CalendarDayBreakdownSchedule';
import CalendarDayNoEvents from '../CalendarDayNoEvents';
import CalendarMonthPicker from '../CalendarMonthPicker';
import { CalendarScreenModeButtons } from '../CalendarScreenModeButtons';
import CalendarSheet from '../CalendarSheet';
import CalendarSheetLeftColumn from '../CalendarSheet/CalendarSheetLeftColumn';
import CalendarSheetRightColumn from '../CalendarSheet/CalendarSheetRightColumn';

interface Props {
  items?: CalendarItemUnion[];

  onPressItem?: (item: CalendarItemUnion) => void;

  onPressCreateItem?: (params?: { start?: string }) => void;
}

const CalendarScreenMonthView: FC<Props> = (props) => {
  const { onPressItem, onPressCreateItem } = props;

  const [active_date_string, setActiveDate] = useStateStore((state) => [
    state.calendar.active_date_string,
    state.calendar.setActiveDate,
  ]);

  const { itemsForDay, isLoading } =
    useGetCalendarItemsForDay(active_date_string);

  const dayHasEvents = itemsForDay && itemsForDay.length > 0;

  const onPressCreate = () => {
    onPressCreateItem?.({ start: active_date_string });
  };

  return (
    <CalendarSheet>
      <CalendarSheetLeftColumn>
        <CalendarScreenModeButtons />

        <CalendarMonthPicker
          selected_date_string={active_date_string}
          focus_date_string={active_date_string}
          onPressDay={setActiveDate}
        />
      </CalendarSheetLeftColumn>

      <CalendarSheetRightColumn>
        <DayHeadingRow>
          <Text variant="h3" weight="semibold">
            {active_date_string
              ? format(new Date(active_date_string), 'eeee d MMM')
              : null}
          </Text>

          {active_date_string &&
          isSameDay(new Date(active_date_string), new Date()) ? (
            <TodayBadge />
          ) : null}
        </DayHeadingRow>

        {isLoading ? (
          <FullScreenLoader />
        ) : dayHasEvents ? (
          <CalendarDayBreakdownSchedule
            items={itemsForDay}
            onPressItem={onPressItem}
          />
        ) : (
          <CalendarDayNoEvents />
        )}

        {onPressCreateItem ? (
          <CreateButtonContainer pointerEvents="box-none">
            <NewButton
              size="large"
              icon="plus"
              onPress={onPressCreate}
              testID="create-calendar-item-button"
            >
              Create event
            </NewButton>
          </CreateButtonContainer>
        ) : null}
      </CalendarSheetRightColumn>
    </CalendarSheet>
  );
};

const DayHeadingRow = styled(Row)`
  padding: 10px;
  padding-bottom: 0;
  gap: 16px;
`;

const CreateButtonContainer = styled.View`
  position: absolute;
  bottom: 10px;
  width: 100%;
  flex-direction: row;
  justify-content: center;
`;

export default CalendarScreenMonthView;
